'use strict';

function controller($http, $attrs, $scope) {
    const vm = this;
    vm.query = '';
    vm.results = null;
    vm.loading = false;

    $scope.$watch('vm.query', (newValue, oldValue) => {

        if (newValue === oldValue) {
            return;
        }

        if (!vm.query) {
            return;
        }

        const url = $attrs.action + '/' + encodeURIComponent(vm.query);

        vm.loading = true;

        $http.get(url).then(response => {
            vm.loading = false;
            vm.results = response.data;
        }).catch(() => {
            vm.loading = false;
        });
    });

    vm.clear = function () {
        vm.results = null;
        vm.query = '';
    }

    return vm;
}

module.exports = [
    '$http',
    '$attrs',
    '$scope',
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/NewsSearch.js